
import gif from "../../images/glowgif01.gif";


import staff from "../../images/staff1.png";
import e from "../../images/e.png";




import team from '../../images/team.png';

import bgImage2 from "../../images/glow.png";
import staffing from "../../images/staffing.jpg";
import './Product.css';
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState, useRef } from 'react';



export const Product = () => {
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo(0, 0);
}
  const [width, setWidth] = useState(window.innerWidth);
  const heroRef = useRef<HTMLDivElement | null>(null);
  const backgroundRef = useRef<HTMLDivElement | null>(null);
 

  useEffect(() => {
    const animateValue = (obj: HTMLElement, start: number, end: number, duration: number) => {
      let startTimestamp: number | null = null;
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = Math.floor(progress * (end - start) + start).toString();
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };
  
    // Select all elements with a specific class
    const elements = document.querySelectorAll<HTMLElement>(".animate-value");
  
    if (elements.length === 0) {
      console.error("No elements with class 'animate-value' found in the DOM.");
      return;
    }
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const endValue = parseInt(target.getAttribute("data-end") || "100", 10); // Use `data-end` for dynamic values
            animateValue(target, 0, endValue, 2000); // Start animation
            observer.unobserve(target); // Stop observing this element after animation starts
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the element is visible
    );
  
    // Observe each element
    elements.forEach((element) => observer.observe(element));
  
    return () => {
      observer.disconnect(); // Cleanup observer on component unmount
    };
  }, []);
  
  useEffect(() => {
    if (heroRef.current && backgroundRef.current) {
      heroRef.current.style.background = 'none';
      backgroundRef.current.style.backgroundImage = `url(${bgImage2})`;
    }
    const handleScroll = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = maxScaleTop;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.transformOrigin = 'bottom right';
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-26.47 * scaleside) + 36.47}%`;
      }
    };
    const handleScrollMobile = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = 1.8;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        // backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.txransformOrigin = 'bottom right';
        // backgroundRef.current.style.top = `${(-22.05 * scaleTop) + 47}%`;
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        // backgroundRef.current.style.left = `${(-30.47 * scaleside) + 26.47}%`;
      }
    };
    const updateScrollHandler = () => {
      const isMobile = window.innerWidth <= 900; // Adjust breakpoint as needed
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
  
      if (isMobile) {
        window.addEventListener('scroll', handleScrollMobile);
      } else {
        window.addEventListener('scroll', handleScroll);
      }
    };
  
    // Set the initial scroll handler
    updateScrollHandler();
     // Update the scroll handler on resize
  window.addEventListener('resize', updateScrollHandler);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
      window.removeEventListener('resize', updateScrollHandler);
    };
}, []);


 
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="wrapper2">
    <section id='hero2' ref={heroRef} className="hero2"
    // style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'auto', background: 'cover' }}
    >
         <div   className='glow_2'></div>

<div ref={backgroundRef} className="background">
<div   ref={backgroundRef}className='glow'></div>
</div>
<div className="background2"></div>
      {/* <div ref={backgroundRef} className="background">
      Staffing
      </div> */}
      <div className='hero__flex'  >
     
      <div className='hero__left'  >
      <div className='img_box'>
      <img src={staffing}  className='intro_img first'  />
      <img src={staff}  className='intro_img'  />
      {/* <img src={staff}  className='intro_img'  />   */}
      <div className='intro_img'>
      <div style={{display:'flex',flexDirection:'row',justifyContent:'center',}}>
        <div className="num animate-value"  data-end="20">0</div>
        <a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a>
        </div>
        <div className="text">Trusted Clients</div>
      </div>
 <div className='intro_img'>
 <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
        <div className="num animate-value"  data-end="100">0</div>
        <a style={{fontSize:'30px',paddingLeft:'0px'}}>+</a>
        </div>
        <div className="text">Candidates filled</div>
      </div>
            </div>
         </div>
        
         <div className='hero__right'  >
         <div>
        <div className='rightbox_paragraph_up'>
     Staffing
            </div>
            <a>-Intell<img src={e} className='elogo' />Sphere</a>
            </div>
           
      <div className='rightbox_paragraph'>
        <a>Navigating the US Talent Landscape, So You Don't Have To
</a><br></br>
      At the heart of it, we know that your success is on the incredible individuals who
make it. Which is where, we at IntelleSphere LLC, ensure connecting you with
the right talent – people who don't just fill roles, but who bring passion, skills, and
a genuine drive to contribute to your team.   </div>
           
           
         </div>
      
      </div>
    </section>

    <div className='section3'>
    {/* <a>WHAT WE DO</a>
            <h1>Services at Tekcog</h1> */}
           <div className='sevices_in'>
         
            <div className='sevices_box animate'>
            <img
            // src={dMedia}
            className='animeImg'
            
            />
            <a>Finding Your Next Great Team Member Feels Personal to Us</a>
           
            <p>Forget
sifting through endless, impersonal resumes. We take the time to truly
understand your company culture, your specific challenges, and the kind of
person who will not only excel in the role but also thrive within your team.
Whether you need someone on a contract basis to inject expertise into a project,
a direct hire who will become a long-term cornerstone of your organization, or an
executive hire with the vision to steer your company forward, we treat each
search with the care and attention it deserves.</p>
        
            </div>
            
            <div className='sevices_box animate'>
            <img
            // src={devops}
            className='animeImg'
            
            />
            <a>We Know Speed and Quality Go Hand-in-Hand:</a>
           
            <p>You need talented
people, and you often need them now. Our commitment to agility means we work

efficiently to identify, vet, and present you with top-tier candidates without
sacrificing the thoroughness that ensures a great long-term fit.</p>
        
            </div>
       
     
            {/* <img
            src={Tlogo}
            className='imageSide'
            
            /> */}
           </div>
           <div className='sevices_in2 '>
         
 

         <div className='sevices_box2 animate'>
         <img
         // src={s}
         className='animeImg'
         
         />
         <a>Building Teams That Scale with Your Ambition</a>
        
         <p>You evolve with your
staffing needs, this is where we offer flexible and scalable talent solutions
designed to adapt to your growth trajectory. From the fast-paced energy of a
startup to the complex demands of a large enterprise, we're here to provide the
right people at the right time, ensuring you have everything that you need to
achieve your goals.</p>
     
         </div>
         <div className='sevices_box2 animate'>
         <img
         // src={dMedia}
         className='animeImg'
         
         />
         <a>Navigating the US Talent Landscape, So You Don't Have To</a>
        
         <p>The US
job market can feel like a maze, with its regulations and ever-shifting trends. We
live and breathe this landscape. We bring our deep understanding of labor laws,
compensation benchmarks, and the nuances of different industries to ensure
your hiring practices are not only compliant but also attract the very best talent
available.</p>
     
         </div>
         {/* <img
         src={Tlogo}
         className='imageSide'
         
         /> */}
        </div>
          
    </div>

    
    <div className='section4_P'>
    <div className='center animate'>
            <img src={gif} className='logoIS' />
             </div>
   <h1>We have formulated our solutions to cater to needs of individual industries and
their custom requirements, our expertise include various sectors like</h1>
<div className='sec_contain'>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Information Technology (IT)</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Healthcare &Life Sciences</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Finance & Accounting</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Engineering & Manufacturing</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Logistics & Supply Chain</h1>
            </div>
            <div className='sec_box'  >
            <img
            src={staffing}
            className='animeImg' />
            <h1>Administrative & Customer Support</h1>
            </div>
           </div>
           <h3>where we cater to Contract Staffing (Temporary & Project-Based), Contract-to-
Hire Staffing, Direct Hire Recruitment, Executive Search & Niche Talent
Acquisition</h3>
           </div>

  
          
    </div>
    
    
  )
}






